import {
  UserPlusIcon,
  MegaphoneIcon,
  ArrowUpTrayIcon,
  WrenchScrewdriverIcon,
  UserGroupIcon,
  EyeSlashIcon,
  MapPinIcon,
  ClockIcon,
  Squares2X2Icon,
  DocumentTextIcon,
  PresentationChartLineIcon,
  GlobeAltIcon,
} from "@heroicons/react/24/outline";
import { NavigationItem } from "./types";

const navigation: NavigationItem[] = [
  {
    name: "Sales and Customer Dashboard",
    href: "/lead-generation/sales-and-customer-dashboard",
    icon: Squares2X2Icon,
    current: false,
    internalName: "dashboard",
    roles: ["ROLE_SUPER_ADMIN", "ROLE_OWNER_GM", "ROLE_MARKETING"],
  },
  {
    name: "ROI Dashboard",
    href: "/lead-generation/roi-dashboard",
    icon: PresentationChartLineIcon,
    current: false,
    internalName: "roi_dashboard",
    roles: ["ROLE_SUPER_ADMIN", "ROLE_OWNER_GM", "ROLE_MARKETING"],
  },
  {
    name: "Total Addressable Market",
    href: "/lead-generation/total-addressable-market",
    icon: GlobeAltIcon,
    current: false,
    internalName: "total_addressable_market",
    roles: ["ROLE_SUPER_ADMIN", "ROLE_OWNER_GM", "ROLE_MARKETING"],
  },
  {
    name: "Prospects",
    href: "/lead-generation/prospects",
    icon: UserPlusIcon,
    current: false,
    internalName: "prospects",
    roles: ["ROLE_SUPER_ADMIN", "ROLE_OWNER_GM", "ROLE_MARKETING"],
  },
  {
    name: "Customers",
    href: "/lead-generation/customers",
    icon: UserGroupIcon,
    current: false,
    internalName: "customers",
    roles: ["ROLE_SUPER_ADMIN", "ROLE_OWNER_GM", "ROLE_MARKETING"],
  },
  {
    name: "Invoices",
    href: "/lead-generation/invoices",
    icon: DocumentTextIcon,
    current: false,
    internalName: "invoices",
    roles: ["ROLE_SUPER_ADMIN", "ROLE_OWNER_GM", "ROLE_MARKETING"],
  },
  {
    name: "Locations",
    href: "/lead-generation/locations",
    icon: MapPinIcon,
    current: false,
    internalName: "locations",
    roles: ["ROLE_SUPER_ADMIN", "ROLE_OWNER_GM", "ROLE_MARKETING"],
  },
  {
    name: "Campaign Management",
    href: "/lead-generation/campaigns",
    icon: MegaphoneIcon,
    current: false,
    internalName: "campaigns",
    roles: ["ROLE_SUPER_ADMIN", "ROLE_OWNER_GM", "ROLE_MARKETING"],
  },
  {
    name: "Uploads",
    href: "#",
    icon: ArrowUpTrayIcon,
    current: false,
    internalName: "dashboards",
    roles: ["ROLE_SUPER_ADMIN", "ROLE_MARKETING"],
    children: [
      {
        name: "Field Service Import",
        href: "/lead-generation/field-service-import",
        icon: WrenchScrewdriverIcon,
        current: false,
        internalName: "field_service_import",
        roles: ["ROLE_SUPER_ADMIN", "ROLE_MARKETING"],
      },
      {
        name: "Prospect Source Import",
        href: "/lead-generation/prospect-source-import",
        icon: UserPlusIcon,
        current: false,
        internalName: "prospect_source_import",
        roles: ["ROLE_SUPER_ADMIN", "ROLE_MARKETING"],
      },
      {
        name: "Do Not Mail Import",
        href: "/lead-generation/do-not-mail-import",
        icon: EyeSlashIcon,
        current: false,
        internalName: "do_not_mail_import",
        roles: ["ROLE_SUPER_ADMIN", "ROLE_MARKETING"],
      },
      {
        name: "Import Status",
        href: "/lead-generation/import-status",
        icon: ClockIcon,
        current: false,
        internalName: "import_status",
        roles: ["ROLE_SUPER_ADMIN", "ROLE_MARKETING"],
      },
    ],
  },
];

const stochasticConfig = {
  sectionName: "stochastic",
  defaultRoute: "/lead-generation/sales-and-customer-dashboard",
  navigation,
};

export default stochasticConfig;
